import { Outlet } from 'react-router-dom'
import SystemNav from 'components/navs/SystemNav'

const SystemLayout = () => {
  return (
    <div>
      <SystemNav />
      <div className='p-6 bg-white shadow-md border border-gray-300 border-t-0'>
        <Outlet />
      </div>
    </div>
  )
}

export default SystemLayout
